import React from 'react'
import PropTypes from 'prop-types'
import FilterItem from './FilterItem'
import { Rating } from '../../../core'
import { Menu, MenuList, MenuLabel } from '../../../bulma'

/**
* Sidebar filter component for ratings.
*/
class RatingFilter extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      // Stores the value that was most recently changed.
      changedValue: null,
    }

    this.onClickHandler = this.onClickHandler.bind(this)
    this.renderRatings = this.renderRatings.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // If no longer loading, clear the `changedValue` so we no longer show
    // a loading indicator on that filter item.
    if (this.props.isLoading && !nextProps.isLoading) {
      this.setState({ changedValue: null })
    }
  }

  /**
  * onClick callback wrapper for when a rating is clicked. Wraps the onChange
  * callback to store the recent changes in state and pass in a label for analytics.
  *
  * @param value {number|string} rating value.
  */
  onClickHandler(value) {
    this.setState({ changedValue: value || 0 })

    this.props.onChange(value, value || 0)
  }

  /**
  * Renders available rating options based on aggregations.
  */
  renderRatings() {
    const {
      value, aggregations, isLoading, getFallbackUrl,
    } = this.props

    return aggregations
      .map((rating, idx) => {
        const isSelected = (value == rating.rating) || (!value && !rating.rating)
        const ratingIsLoading = isLoading && this.state.changedValue === rating.rating
        const clickValue = rating.rating && value !== rating.rating ? rating.rating : null
        const fallbackUrl = getFallbackUrl ? getFallbackUrl(clickValue) : null

        return (
          <FilterItem
            key={rating.rating}
            onClick={() => this.onClickHandler(clickValue)}
            fallbackUrl={fallbackUrl}
            allowMultiple={false}
            count={(rating.rating && idx) ? '& up' : null}
            isDisabled={isLoading}
            isLoading={ratingIsLoading}
            isSelected={isSelected}
          >
            {rating.rating ? <Rating average={rating.rating} /> : 'Any Rating' }
          </FilterItem>
        )
      })
  }

  render() {
    const {
      title, value, aggregations, isLoading, onChange, getFallbackUrl, className, ...rest
    } = this.props

    const classes = [
      className || '',
      'is-shadowless',
    ]

    return (
      <Menu {...rest} className={classes.join(' ')}>
        {title ? <MenuLabel>{title}</MenuLabel> : false}
        <MenuList>
          {this.renderRatings()}
        </MenuList>
      </Menu>
    )
  }
}

RatingFilter.defaultProps = {
  aggregations: [],
  isLoading: false,
}

RatingFilter.propTypes = {
  // Rating aggregations.
  aggregations: PropTypes.array,
  // Products/filters are currently loading.
  isLoading: PropTypes.bool,
  // Callback for when a rating filter changes.
  onChange: PropTypes.func.isRequired,
  // Display name for filter.
  title: PropTypes.string,
  // Current value of filter.
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}

export default RatingFilter
